
import React, { useState } from 'react'
import { Container, Header, Icon, Menu, Grid, Image, Label, Rail, Button } from 'semantic-ui-react'
import { useTranslation } from "react-i18next";
import ReactBnbGallery from 'react-bnb-gallery';
import VisibilitySensor from "react-visibility-sensor"


const Section1 = ({ visibilyChange }) => {

    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation();

    const PHOTOS = ['https://www.trulia.com/pictures/thumbs_6/zillowstatic/fp/090d499223d678fa9fc3158ce52f2f65-full.webp', 'https://www.trulia.com/pictures/thumbs_5/zillowstatic/fp/37cdfd59075fe1a0c5c95098c16bc318-full.webp'];

    return (
        <VisibilitySensor partialVisibility={true} onChange={visibilyChange}>
            <Container className="bg-white" id="property-section1">
                <Header as='h2' className="d-flex flex-row align-items-end">
                    {t("property:PropertyCode")} :  <span className="m-05-r m-05-l">2956385</span>
                </Header>
                <Menu secondary className="align-items-center">

                    <Label  basic className="border-none white-nowrap">
                        {/* <Icon name="calendar alternate" /> */}
                        {t("property:DateOfRegistration")} :
                        <span className="m-05-r m-05-l">چهار شنبه 2 تیر ۱۴۰۰</span>
                    </Label>

                    <Label  basic className="border-none white-nowrap p-0">
                        {/* <Icon name="eye" /> */}
                        {t("property:NumberOfViews")} :
                        <span className="m-05-r m-05-l">255</span>

                    </Label>
                    <Menu.Menu position='right'>
                        <Label as="a" basic className="border-none">
                            <Icon className="m-0" name='share square outline' /> {t("property:Share")}
                        </Label>
                        <Label as="a" basic className="border-none">
                            <Icon className="m-0" name='heart outline' /> {t("property:Save")}
                        </Label>

                    </Menu.Menu>
                </Menu>

                <Grid columns={3} className="h-min-350">
                    <Grid.Row stretched>
                        <Grid.Column width={8} className="p-4px-l p-0-r">

                            <Image className='m-4px-b rounded-right-30' src='https://www.trulia.com/pictures/thumbs_6/zillowstatic/fp/090d499223d678fa9fc3158ce52f2f65-full.webp' />
                            <Button color="black" className="position-absolute bottom-4 right-4" onClick={() => setIsOpen(true)}>
                                <Icon name="th" />
                                {t("property:ShowAllPhotos")}

                            </Button>
                        </Grid.Column >
                        <Grid.Column width={4} className="p-4px-l p-0-r">
                            <Image className='m-4px-b' src='https://www.trulia.com/pictures/thumbs_5/zillowstatic/fp/f2c08f7454ff017aabd7615972c8111e-full.webp' />
                            <Image className='m-4px-b' src='https://www.trulia.com/pictures/thumbs_4/zillowstatic/fp/32691624ac39e4614accee58f8e5ba68-full.webp' />
                        </Grid.Column>
                        <Grid.Column width={4} className="p-4px-l p-0-r">
                            <Image className='m-4px-b rounded-left-top-30' src='https://www.trulia.com/pictures/thumbs_6/zillowstatic/fp/090d499223d678fa9fc3158ce52f2f65-full.webp' />
                            <Image className='m-4px-b rounded-left-bottom-30' src='https://www.trulia.com/pictures/thumbs_5/zillowstatic/fp/f2c08f7454ff017aabd7615972c8111e-full.webp' />
                        </Grid.Column>
                    </Grid.Row>

                    <ReactBnbGallery
                        show={isOpen}
                        photos={PHOTOS}
                        onClose={() => setIsOpen(false)}
                    />
                </Grid>
            </Container>
        </VisibilitySensor>

    )
}
export default Section1